import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from './components/ui/sonner';
import { AuthProvider } from './contexts/AuthContext';
import Header from './components/Header';
import Footer from './components/Footer';
import EmailCaptureBanner from './components/EmailCaptureBanner';
import InstallPWA from './components/InstallPWA';
import HomePage from './pages/HomePage';
import PropertiesPage from './pages/PropertiesPage';
import PropertyDetailPage from './pages/PropertyDetailPage';
import CalendarPage from './pages/CalendarPage';
import AuctionDatesPage from './pages/AuctionDatesPage';
import FinancePage from './pages/FinancePage';
import DisclaimerPage from './pages/DisclaimerPage';
import TermsOfServicePage from './pages/TermsOfServicePage';
import ListingRemovalPage from './pages/ListingRemovalPage';
import DashboardLayout from './pages/DashboardLayout';
import SavedPropertiesPage from './pages/SavedPropertiesPage';
import SavedSearchesPage from './pages/SavedSearchesPage';
import AlertSubscriptionsPage from './pages/AlertSubscriptionsPage';
import AdminDashboard from './pages/AdminDashboard';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <div className="flex flex-col min-h-screen">
          <Header />
          <EmailCaptureBanner />
          <main className="flex-grow">
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/properties" element={<PropertiesPage />} />
              <Route path="/properties/:propertyId" element={<PropertyDetailPage />} />
              <Route path="/calendar" element={<CalendarPage />} />
              <Route path="/auction-dates" element={<AuctionDatesPage />} />
              <Route path="/finance" element={<FinancePage />} />
              <Route path="/disclaimer" element={<DisclaimerPage />} />
              <Route path="/terms" element={<TermsOfServicePage />} />
              <Route path="/listing-removal" element={<ListingRemovalPage />} />
              <Route path="/dashboard" element={<DashboardLayout />}>
                <Route index element={<Navigate to="/dashboard/saved" replace />} />
                <Route path="saved" element={<SavedPropertiesPage />} />
                <Route path="searches" element={<SavedSearchesPage />} />
                <Route path="alerts" element={<AlertSubscriptionsPage />} />
              </Route>
              <Route path="/admin" element={<AdminDashboard />} />
            </Routes>
          </main>
          <Footer />
        </div>
        <InstallPWA />
        <Toaster />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;